<div class="d-flex">
  <!-- UNDO -->
  <div>
    <a class="btn btn-sm text-light" (click)="undo()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Undo">
      @if (canUndo) {
        <i class="fa-solid fa-share fa-flip-horizontal"></i>
      } @else {
        <i class="fa-solid fa-share fa-flip-horizontal"></i>
      }
    </a>
  </div>

  <!-- REDO -->
  <div>
    <a class="btn btn-sm text-light" (click)="redo()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Redo">
      @if (canRedo) {
        <i class="fa-solid fa-share"></i>
      } @else {
        <i class="fa-solid fa-share"></i>
      }
    </a>
  </div>
</div>